import React from 'react';
import styles from '../assets/css/Preloader.module.css'; // Import NEW CSS Module
import { AuthContext } from '../context/AuthContext'; // Import context if logo comes from there
import { useContext } from 'react'; // Import useContext

function Preloader({ status }) {
    const { app_logo = "/favicon.png" } = useContext(AuthContext); // Get logo from context

    // Render nothing if status is false
    if (!status) {
        return null;
    }

    return (
        // Use the CSS module class for the main container
        <div className={styles.preloaderOverlay}>
            <div className={styles.loaderContainer}>
                {/* App Logo */}
                <img src={app_logo} alt="Loading Logo" className={styles.loaderLogo} />

                {/* --- Loader Animation --- */}
                {/* Choose one of the loader divs below and comment out the other */}

                {/* Option 1: Pulsing Dots Loader */}
                <div className={styles.pulsingDotsLoader}>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>

                {/* Option 2: Rotating Border Loader */}
                {/* <div className={styles.rotatingBorderLoader}></div> */}

                {/* Loading Text */}
                <p className={styles.loadingText}>Loading...</p>
            </div>
        </div>
    );
}

export default Preloader;
